import Vue from 'vue'
import Router from 'vue-router'
import Start from '@/Pages/Start'

Vue.use(Router)

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      name: 'Start',
      component: Start
    },
    { path: '*', redirect: '/' }, // catch all use case
  ],
})


// WEBPACK FOOTER //
// ./src/router/index.js